import { useEffect } from "react"

import { useNavigate, useLocation, useSearchParams } from "react-router-dom"
import { useAppSelector } from 'shared/config/store'
import { isAuthSelector } from 'features/user/model/selectors/userSelectors'

const getRedirectPath = (basePath:string, searchParamsString:string) => {
  return searchParamsString ? `${basePath}?${searchParamsString}` : `${basePath}`
}

const InvitePage = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const isAuth = useAppSelector(isAuthSelector)
  const [searchParams] = useSearchParams()

  useEffect(() => {
    const searchParamsStr = searchParams.toString()
    let basePath = '/'
    let fullPath = '/'
    if (isAuth) {
      basePath = '/dashboard'
    }
    fullPath = getRedirectPath(basePath, searchParamsStr)
    navigate(fullPath, { replace: true })
  }, [isAuth, location.search, navigate, searchParams])

  return null
}

export default InvitePage
